
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-dasharray":"16","stroke-dashoffset":"16","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M12 3a9 9 0 019 9"}},[_c('animate',{attrs:{"fill":"freeze","attributeName":"stroke-dashoffset","dur":"0.2s","values":"16;0"}}),_c('animateTransform',{attrs:{"attributeName":"transform","dur":"1.5s","repeatCount":"indefinite","type":"rotate","values":"0 12 12;360 12 12"}})])])
          )
        }
      }
    